/**
 * Cliente API de SALDOS_BANCARIOS (Sprint 17 Fase 2).
 *
 * Consume:
 * - GET /saldos-bancarios/ (paginado).
 * - GET /saldos-bancarios/calculado-hoy.
 * - POST /saldos-bancarios/ (tesorero registra).
 */
import { apiFetch } from './client';

export interface SaldoBancarioRead {
  id: string;
  fecha_registro: string; // YYYY-MM-DD
  hora_registro: string; // HH:MM:SS
  saldo_banco: number;
  saldo_calculado: number;
  diferencia: number;
  notas: string | null;
  registrado_por_usuario_id: string;
  creado_at: string;
  actualizado_at: string;
}

// Modelo independiente (2026-06-25): el saldo del sistema se reconstruye
// desde la apertura del año, no se ancla al último registro.
export interface SaldoCalculadoHoyResponse {
  anio: number;
  apertura: number | null;
  sin_apertura: boolean;
  saldo_calculado: number | null;
  ingresos_anio: number;
  gastos_anio: number;
  traspasos_dap_anio: number;
  ultimo_registro_fecha: string | null;
  ultimo_registro_saldo_banco: number | null;
  diferencia: number | null; // banco (último registro) − saldo_calculado
}

export interface RegistrarSaldoInput {
  saldo_banco: number;
  fecha_registro?: string; // opcional
  hora_registro?: string; // opcional
  notas?: string | null;
}

export function listSaldosBancarios(
  limit = 50,
  offset = 0,
): Promise<SaldoBancarioRead[]> {
  return apiFetch<SaldoBancarioRead[]>(
    `/saldos-bancarios/?limit=${limit}&offset=${offset}`,
  );
}

export function getSaldoCalculadoHoy(): Promise<SaldoCalculadoHoyResponse> {
  return apiFetch<SaldoCalculadoHoyResponse>(
    '/saldos-bancarios/calculado-hoy',
  );
}

export function crearSaldoBancario(
  data: RegistrarSaldoInput,
): Promise<SaldoBancarioRead> {
  return apiFetch<SaldoBancarioRead>('/saldos-bancarios/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
